import { message } from 'antd';

message.config({
  top: '40%'
});

export default class AntdMessage {
  static warning = message.warning;
  static info = message.info;
  static error = message.error;
  static success = message.success;
}
